import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Client } from '@core/services/client/client.model';

export enum ClientActionTypes{
    LOAD_CLIENTS="[Client] Load Clients",
    LOAD_CLIENTS_SUCCESS="[Client] Load Clients Success",
    LOAD_CLIENTS_FAIL="[Client] Load Clients Fail",
    LOAD_CLIENT="[Client] Load Client",
    LOAD_CLIENT_SUCCESS="[Client] Load Client Success",
    LOAD_CLIENT_FAIL="[Client] Load Client Fail",
    CREATE_CLIENT="[Client] Create Client",
    CREATE_CLIENT_SUCCESS="[Client] Create Client Success",
    CREATE_CLIENT_FAIL="[Client] Create Client Fail",
    UPDATE_CLIENT="[Client] Update Client",
    UPDATE_CLIENT_SUCCESS="[Client] Update Client Success",
    UPDATE_CLIENT_FAIL="[Client] Update Client Fail",
    UPDATE_CLIENT_TOBE_INACTIVE="[Client] Update Client to be Inactive",
    UPDATE_CLIENT_TOBE_INACTIVE_SUCCESS="[Client] Update Client to be Inactive Success",
    UPDATE_CLIENT_TOBE_INACTIVE_FAIL="[Client] Update Client to be Inactive Fail",
}

export class LOADCLIENTS implements Action{
   readonly type=ClientActionTypes.LOAD_CLIENTS;
}

export class LOADCLIENTSSUCCESS implements Action{
    readonly type=ClientActionTypes.LOAD_CLIENTS_SUCCESS;
    constructor(public payload:Client[]) {}
 }

 export class LOADCLIENTSFAIL implements Action{
    readonly type=ClientActionTypes.LOAD_CLIENTS_FAIL;
    constructor(public payload:string) {}
 }

 export class LOADCLIENT implements Action{
    readonly type=ClientActionTypes.LOAD_CLIENT;
    constructor(public payload:number) {}
 }

 export class LOADCLIENTSUCCESS implements Action{
     readonly type=ClientActionTypes.LOAD_CLIENT_SUCCESS;
     constructor(public payload:Client) {}
  }

  export class LOADCLIENTFAIL implements Action{
     readonly type=ClientActionTypes.LOAD_CLIENT_FAIL;
     constructor(public payload:string) {}
  }

  export class CREATECLIENT implements Action{
    readonly type=ClientActionTypes.CREATE_CLIENT;
    constructor(public payload:Client) {}
 }

 export class CREATECLIENTSUCCESS implements Action{
     readonly type=ClientActionTypes.CREATE_CLIENT_SUCCESS;
     constructor(public payload:Client) {}
  }

  export class CREATECLIENTFAIL implements Action{
     readonly type=ClientActionTypes.CREATE_CLIENT_FAIL;
     constructor(public payload:string) {}
  }

  
  export class UPDATECLIENT implements Action{
    readonly type=ClientActionTypes.UPDATE_CLIENT;
    constructor(public payload:Client) {}
 }

 export class UPDATECLIENTSUCCESS implements Action{
     readonly type=ClientActionTypes.UPDATE_CLIENT_SUCCESS;
     constructor(public payload:Update<Client>) {}
  }

  export class UPDATECLIENTFAIL implements Action{
     readonly type=ClientActionTypes.UPDATE_CLIENT_FAIL;
     constructor(public payload:string) {}
  }

  export class UPDATECLIENTTOBEINACTIVE implements Action{
   readonly type=ClientActionTypes.UPDATE_CLIENT_TOBE_INACTIVE;
   constructor(public payload:string) {}
}

export class UPDATECLIENTTOBEINACTIVE_SUCCESS implements Action{
    readonly type=ClientActionTypes.UPDATE_CLIENT_TOBE_INACTIVE_SUCCESS;

    constructor(public payload:Update<Client>) {}
 }

 export class UPDATECLIENTTOBEINACTIVEFAIL implements Action{
    readonly type=ClientActionTypes.UPDATE_CLIENT_TOBE_INACTIVE_FAIL;

    constructor(public payload:string) {}
 }


  export type ClientsAction=
  | LOADCLIENTS  
  | LOADCLIENTSSUCCESS 
  | LOADCLIENTSFAIL 
  | LOADCLIENT  
  | LOADCLIENTSUCCESS 
  | LOADCLIENTFAIL 
  | CREATECLIENT 
  | CREATECLIENTSUCCESS 
  | LOADCLIENTFAIL 
  | CREATECLIENT 
  | CREATECLIENTSUCCESS
  | CREATECLIENTFAIL
  | UPDATECLIENT 
  | UPDATECLIENTSUCCESS
  | UPDATECLIENTFAIL 
  | UPDATECLIENTTOBEINACTIVE
  | UPDATECLIENTTOBEINACTIVE_SUCCESS
  | UPDATECLIENTTOBEINACTIVEFAIL;